import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import MessageListItemNoMargin
  from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageListItemNoMargin';

const MessageListItemPicker = ({ messageResource, ...rest }) => {
  return (
    <MessageListItemNoMargin messageResource={messageResource} {...rest} />
  );
};

MessageListItemPicker.propTypes = {
  messageResource: PropTypes.instanceOf(fr.Resource).isRequired,
};
MessageListItemPicker.defaultProps = {};

export default MessageListItemPicker;
